// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"7":"84e9f68e","131":"54e7a588","348":"878cec78","556":"d7bc8b1b","559":"366dd93c","723":"0affba1c","730":"77d05f0d","890":"b97bf6a9"}[chunkId] + ".js";
};